import "./App.css";
import video from "./media/alinasec_1.mp4";
import Contenitore2 from "./elementi/contenitore2";
import Cookie from "./elementi/cookie";

function App() {
  return (
    <div style={{ height: '100%', position: 'absolute', left: '0px', width: '100%', overflow: 'hidden'}}>
      <header id="contenitore">
        <div className="overlay"></div>

        <video
          id="video"
          playsInline="playsinline"
          autoPlay="autoplay"
          muted="muted"
          loop="loop"
          src={video}
          type="video/mp4"
        ></video>

        <Contenitore2 />
        <Cookie />
      </header>
    </div>
  );
}

export default App;
